import script from "./AssetLibraryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetLibraryCard.vue?vue&type=script&setup=true&lang=js"

import "./AssetLibraryCard.vue?vue&type=style&index=0&id=6ba62938&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba62938"]])

export default __exports__